import { render, staticRenderFns } from "./Show2.vue?vue&type=template&id=641c79be&scoped=true&"
import script from "./Show2.vue?vue&type=script&lang=js&"
export * from "./Show2.vue?vue&type=script&lang=js&"
import style0 from "./Show2.vue?vue&type=style&index=0&id=641c79be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c79be",
  null
  
)

export default component.exports